import { useMutation, gql } from "@apollo/client"
import { ADMINABLE_USERS_FIELDS } from "./useQueryAdminableUsers"

const CREATE_USER_MUTATION = gql`
  ${ADMINABLE_USERS_FIELDS}
  mutation CreateUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $avatar: String
    $groups: [ID!]
    $locations: [ID!]!
    $trainingCourse: ID
    $roles: [String!]
    $invite: Boolean!
  ) {
    createUser(
      firstName: $firstName
      lastName: $lastName
      email: $email
      avatar: $avatar
      groups: $groups
      locations: $locations
      trainingCourse: $trainingCourse
      roles: $roles
      invite: $invite
    ) {
      ...AdminableUsersFields
    }
  }
`

const useMutationCreateUser = () => useMutation(CREATE_USER_MUTATION)

export { useMutationCreateUser }
